import { render, staticRenderFns } from "./CoursewareToolsContents.vue?vue&type=template&id=09279388&scoped=true&"
import script from "./CoursewareToolsContents.vue?vue&type=script&lang=js&"
export * from "./CoursewareToolsContents.vue?vue&type=script&lang=js&"
import style0 from "./CoursewareToolsContents.vue?vue&type=style&index=0&id=09279388&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09279388",
  null
  
)

export default component.exports